import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38059341"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex justify-content-center align-items-center flex-column" }
const _hoisted_2 = { class: "title my-3 my-lg-5" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "description text" }

import Button from '@/components/button/index.vue'
import { useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const transitAlumniLogin = () => {
  router.push('/alumni/login')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('SA23title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('SA23descriptionFirst')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translate)('SA23descriptionSecond')), 1)
    ]),
    _createVNode(Button, {
      title: _unref(translate)('toLoginScreen'),
      type: 'secondary',
      onClick: transitAlumniLogin
    }, null, 8, ["title"])
  ]))
}
}

})